import { Component } from 'react';
import ReactHtmlParser from 'react-html-parser';

let captchaValue = '';
let captchaNumber = '';
let backgroundColorValue = '';
let fontColorValue = '';
let charMapValue = '';
let LoadCanvasTemplateHTML = '<div><canvas id="canv"></canvas><div><a id="reloadHref"  style="cursor: pointer; color: blue">Reload Captcha</a></div></div>';
const LoadCanvasTemplateNoReloadHTML = '<div><canvas id="canv"></canvas><div><a id="reloadHref"  style="cursor: pointer; color: blue"></a></div></div>';


export const loadCaptchaEnginge = (numberOfCharacters, backgroundColor = 'white', fontColor = 'black', charMap = '') => {
  backgroundColorValue = backgroundColor;
  fontColorValue = fontColor;
  charMapValue = charMap;
  captchaNumber = numberOfCharacters;
  let retVal = '';
  let charset = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
  if (charMap === 'upper') {
    charset = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
  } else if (charMap === 'lower') {
    charset = 'abcdefghijklmnopqrstuvwxyz0123456789';
  } else if (charMap === 'numbers') {
    charset = '0123456789';
  } else if (charMap === 'specialChar') {
    charset = "~`!@#$%^&*()_+-=[]{}|:'<>,.?/";
  }

  const length = parseInt(numberOfCharacters, 10);


  // eslint-disable-next-line no-plusplus
  for (let i = 0, n = charset.length; i < length; ++i) {
    retVal += charset.charAt(Math.floor(Math.random() * n));
  }

  const captcha = retVal;

  captchaValue = captcha;


  // const lengthHeightCanvas = Math.round(parseInt(length, 10) / 3);

  const canvas = document.getElementById('canv');
  const ctx = canvas.getContext('2d');
  const text = captcha;
  const lineheight = 30;

  if (ctx && canvas) {
    // const canvasHeight = (parseInt(length) - parseInt(lengthHeightCanvas)) * 20;
    const lines = text.split('\n');
    // const lineLengthOrder = lines.slice(0).sort((a, b) => b.length - a.length);
    ctx.canvas.width = parseInt(length, 10) * 25;
    ctx.canvas.height = (lines.length * lineheight);
    ctx.fillStyle = backgroundColor;
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    ctx.textBaseline = 'middle';
    ctx.font = 'italic 20px Arial';
    ctx.fillStyle = fontColor;
    let num = 0;
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < parseInt(length, 10); i++) {
      num = parseInt(num, 10) + 1;
      const heigtNum = 20 * num;
      ctx.fillText(retVal[i], heigtNum, Math.round(Math.random() * (15 - 12) + 12));
    }
  }

  // eslint-disable-next-line func-names
  document.getElementById('reloadHref').onclick = function () {
    loadCaptchaEnginge(captchaNumber, backgroundColor, fontColor, charMap);
  };
};

export const validateCaptcha = (userValue, reload = true) => {
  if (userValue !== captchaValue) {
    if (reload === true) {
      loadCaptchaEnginge(captchaNumber, backgroundColorValue, fontColorValue, charMapValue);
    }

    return false;
  }


  return true;
};

export class LoadCanvasTemplate extends Component {
  render() {
    let reloadText = '';
    let reloadColor = '';
    LoadCanvasTemplateHTML = '<div><canvas id="canv" style="background-color: blue;"></canvas><div><a id="reloadHref"  style="cursor: pointer; color: blue">Reload Captcha</a></div></div>';

    // eslint-disable-next-line react/destructuring-assignment
    if (this.props.reloadText) {
      // eslint-disable-next-line prefer-destructuring, react/destructuring-assignment
      reloadText = this.props.reloadText;
    }

    // eslint-disable-next-line react/destructuring-assignment
    if (this.props.reloadColor) {
      // eslint-disable-next-line prefer-destructuring, react/destructuring-assignment
      reloadColor = this.props.reloadColor;
    }

    if (reloadText === '') {
      reloadText = 'Reload Captcha';
    }

    if (reloadColor === '') {
      reloadColor = 'blue';
    }

    LoadCanvasTemplateHTML = `<div><canvas id="canv"></canvas><div><a id="reloadHref"  style="cursor: pointer; color: ${reloadColor}">${reloadText}</a></div></div>`;

    return (ReactHtmlParser(LoadCanvasTemplateHTML));
  }
}

export class LoadCanvasTemplateNoReload extends Component {
  render() {
    return (ReactHtmlParser(LoadCanvasTemplateNoReloadHTML));
  }
}
